import { Link } from 'react-router'
import { useIsDealerOrg, useOrgCodeOrUndefined } from 'shared-ui/active-operation'

import { PanoramaLogoIcon } from './PanoramaLogoIcon'
import { PanoramaLogoText } from './PanoramaLogoText'

export const PanoramaLogoLink = () => {
  const orgCode = useOrgCodeOrUndefined()
  const isInOrgScopedRoute = Boolean(orgCode)
  const isDealerOrg = useIsDealerOrg()
  const homepage = isInOrgScopedRoute
    ? isDealerOrg
      ? `/${orgCode}/dealer`
      : `/${orgCode}/home`
    : '/'

  return (
    <Link
      className="logo-print-float flex items-center gap-4 p-0 print:visible"
      to={homepage}
      aria-label="Panorama Home"
    >
      <span className="relative">
        <PanoramaLogoIcon />
        <span className="absolute -right-3 -top-0.5 text-xs leading-none text-white sm:hidden">
          ®
        </span>
      </span>
      <span className="hidden sm:contents">
        <PanoramaLogoText />
      </span>
    </Link>
  )
}
